import axios from 'axios/dist/axios';

const relatedSymptomStates = {
    NONE: "NONE", //The Symptom is not selected
    HAVE_SYMPTOM: "HAVE_SYMPTOM", //The Symptom is selected. The person has that Symptom
    NOT_HAVE_SYMPTOM: "NOT_HAVE_SYMPTOM" //The person tells that he doesn't have that Symptom
};

const defaultState = {
    relatedSymptomStates: relatedSymptomStates, // Constants.

    relatedSymptomList: [],
    selectedRelatedSymptomList: [],
    sharedQuestionsData: [],

    isQuestionListModeEnabled: false,

    mustShowFullQuestion: true,
    footerBtnNext: {
        isEnabled: true
    },
    selectedMainSymptom: '',
    selectedRelatedSymptomListPriority: [],
    symptomDescription:'',
    symptomCode: '',
    mustShowAssessmentList: false,
    symptomName: '',
    symptomText: '',
    relatedSymptomName: '',
    answerCode: '',
    noOtherSymptomsCheck: false,
    noOtherSymptoms: false
};

// ======================================================================
// Initial State
// ======================================================================

const state = {
    relatedSymptomStates:               defaultState.relatedSymptomStates, // Constants.

    relatedSymptomList:                 defaultState.relatedSymptomList,
    selectedRelatedSymptomList:         defaultState.selectedRelatedSymptomList,
    sharedQuestionsData:                defaultState.sharedQuestionsData,

    isQuestionListModeEnabled:          defaultState.isQuestionListModeEnabled,

    mustShowFullQuestion:               defaultState.mustShowFullQuestion,
    footerBtnNext: {
        isEnabled:                      defaultState.footerBtnNext.isEnabled
    },
    selectedMainSymptom:                defaultState.selectedMainSymptom,
    selectedRelatedSymptomListPriority: defaultState.selectedRelatedSymptomListPriority,
    symptomDescription                : defaultState.symptomDescription,
    symptomCode                       : defaultState.symptomCode,
    mustShowAssessmentList            : defaultState.mustShowAssessmentList,
    symptomName                       : defaultState.symptomName,
    symptomText                       : defaultState.symptomText,
    relatedSymptomName                : defaultState.relatedSymptomName,
    answerCode                        : defaultState.answerCode,
    noOtherSymptomsCheck              : defaultState.noOtherSymptomsCheck,
    noOtherSymptoms                   : defaultState.noOtherSymptoms
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getRelatedSymptomStates: state => state.relatedSymptomStates,

    getRelatedSymptomList: state => state.relatedSymptomList,
    getSelectedRelatedSymptomList: state => state.selectedRelatedSymptomList,

    getSharedQuestionList (state) {
        return (typeof state.sharedQuestionsData.questions !== 'undefined')
            ? state.sharedQuestionsData.questions
            : [];
    },
    getSharedQuestionsCountAnswered () {
        return state.sharedQuestionsData.countAnswered || 0;
    },
    getSharedQuestionsCountTotal () {
        return state.sharedQuestionsData.countTotal || 0;
    },

    getIsQuestionListModeEnabled: state => state.isQuestionListModeEnabled,
    getMustShowFullQuestion: state => state.mustShowFullQuestion,
    getIsFooterNextBtnEnabled (state) {
        return (state.footerBtnNext.isEnabled) ? true : false;
    },
    getMainSymptom: state => state.selectedMainSymptom,
    getSelectedRelatedSymptomListPriority: state => state.selectedRelatedSymptomListPriority,
    getSymptomDescription: state => state.symptomDescription,
    getSymptomCode: state => state.symptomCode,
    getMustShowAssessmentList: state => state.mustShowAssessmentList,
    getSymptomName: state => state.symptomName,
    getSymptomText: state => state.symptomText,
    getRelatedSymptomName: state => state.relatedSymptomName,
    getAnswerCode: state => state.answerCode,
    getNoOtherSymptomsCheck: state => state.noOtherSymptomsCheck,
    getNoOtherSymptoms: state => state.noOtherSymptoms
};


// ======================================================================
// Actions
// ======================================================================

const actions = {

    /**
     * Load symptom questions data from the server.
     * @param {Object} - Vuex: commit, rootGetters
     * @return {Promise}
     */
    loadRelatedSymptomList({commit}) {
        let promise = new Promise((resolve, reject) => {

            let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/relatedSymptomList');
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {

                    if (typeof response.data.data !== "undefined"
                        && response.data.data !== null
                        && typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined"
                        && response.data.data.RELATED_SYMPTOM_LIST !== null
                        && typeof response.data.data.RELATED_SYMPTOM_LIST.symptoms !== "undefined") {

                        commit("setRelatedSymptomList", response.data.data.RELATED_SYMPTOM_LIST.symptoms);

                        if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined" && typeof response.data.data.RELATED_SYMPTOM_LIST.noOtherSymptomsCheck) {
                            commit("setNoOtherSymptomsCheck", response.data.data.RELATED_SYMPTOM_LIST.noOtherSymptomsCheck);
                        }

                        if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined" && typeof response.data.data.RELATED_SYMPTOM_LIST.noOtherSymptoms) {
                            commit("setNoOtherSymptoms", response.data.data.RELATED_SYMPTOM_LIST.noOtherSymptoms);
                        }

                        resolve(response);
                    } else {
                        reject("Invalid or missing related symptoms data.");
                    }
                } else {
                    reject(response);
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },


    /**
     * Actions to do when related symptoms checkboxes are toggled.
     * @param {Object} - Vuex: dispatch, commit
     * @param {Object} data - Object containing the following properties:
     *              - {String} "newSymptomState" - new symptom state value. See relatedSymptomStates for values;
     *              - {Number} "symptomCode" - Code of the symptom that has been changed.
     */
    handleChangeRelatedSymptomState({dispatch, commit}, data) {

        switch (data.newSymptomState) {
            case relatedSymptomStates.HAVE_SYMPTOM:
                dispatch("submitCheckSymptomYes", data.symptomCode).then((response) => {

                    if(response.data.data.SYMPTOM_LIST) {
                        commit('setSelectedRelatedSymptomList', response.data.data.SYMPTOM_LIST.symptoms);
                    } else if(response.data.data.SYMPTOM_LIST_PRIORITY){
                        commit('setSelectedRelatedSymptomListPriority', response.data.data.SYMPTOM_LIST_PRIORITY.questions);
                    }
                    dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });

                    // ------- Refresh RELATED SYMPTOM list. -------
                    if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined"
                        && typeof response.data.data.RELATED_SYMPTOM_LIST.symptoms !== "undefined"
                        && response.data.data.RELATED_SYMPTOM_LIST.symptoms.length > 0) {
                        commit("setRelatedSymptomList", response.data.data.RELATED_SYMPTOM_LIST.symptoms);
                    }

                    // ------- Refresh SHARED question list. -------
                    if (typeof response.data.data.SHARED_QUESTIONS !== "undefined") {
                        commit("setSharedQuestionsData", response.data.data.SHARED_QUESTIONS);
                    }
                });
                break;
            case relatedSymptomStates.NOT_HAVE_SYMPTOM:
                dispatch("submitCheckSymptomNo", data.symptomCode).then((response) => {
                    commit("removeSelectedSymptomFromList", data.symptomCode);
                    dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });

                    // ------- Refresh SHARED question list. -------
                    if (typeof response.data.data.SHARED_QUESTIONS !== "undefined") {
                        commit("setSharedQuestionsData", response.data.data.SHARED_QUESTIONS);
                    }

                    // ------- Refresh RELATED SYMPTOM list. -------
                    if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined"
                        && typeof response.data.data.RELATED_SYMPTOM_LIST.symptoms !== "undefined"
                        && response.data.data.RELATED_SYMPTOM_LIST.symptoms.length > 0) {
                        commit("setRelatedSymptomList", response.data.data.RELATED_SYMPTOM_LIST.symptoms);
                    }

                    // ------- Refresh SYMPTOMS list. -------
                    if (typeof response.data.data.SYMPTOM_LIST !== "undefined") {
                        commit('setSelectedRelatedSymptomList', response.data.data.SYMPTOM_LIST.symptoms );
                    } else if(response.data.data.SYMPTOM_LIST_PRIORITY){
                        commit('setSelectedRelatedSymptomListPriority', response.data.data.SYMPTOM_LIST_PRIORITY.questions);
                    }
                });
                break;
            case relatedSymptomStates.NONE:
                dispatch("submitUncheckSymptom", data.symptomCode).then((response) => {
                    commit("removeSelectedSymptomFromList", data.symptomCode);
                    dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });

                    // ------- Refresh SHARED question list. -------
                    if (typeof response.data.data.SHARED_QUESTIONS !== "undefined") {
                        commit('setSharedQuestionsData', response.data.data.SHARED_QUESTIONS);
                    }

                    // ------- Refresh RELATED SYMPTOM list. -------
                    if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined"
                        && typeof response.data.data.RELATED_SYMPTOM_LIST.symptoms !== "undefined"
                        && response.data.data.RELATED_SYMPTOM_LIST.symptoms.length > 0) {
                        commit("setRelatedSymptomList", response.data.data.RELATED_SYMPTOM_LIST.symptoms);
                    }

                    // ------- Refresh SYMPTOMS list. -------
                    if (typeof response.data.data.SYMPTOM_LIST !== "undefined") {
                        commit('setSelectedRelatedSymptomList', response.data.data.SYMPTOM_LIST.symptoms );
                    } else if(response.data.data.SYMPTOM_LIST_PRIORITY){
                        commit('setSelectedRelatedSymptomListPriority', response.data.data.SYMPTOM_LIST_PRIORITY.questions);
                    }
                });
                break;
        }
    },


    /**
     * Make sure that Selected Symptom List only contains the Main Symptom and the symptoms that are
     *      in Related Symptoms List and have HAVE_SYMPTOM status.
     * @param {Object} - Vuex: commit, getters.
     * @return {Void}
     */
    rectifySelectedSymptomList({commit, getters}) {

        let getMainSymptom = getters.getMainSymptom;
        let getRelatedSymptomList = getters.getRelatedSymptomList;
        let getSelectedRelatedSymptomList = getters.getSelectedRelatedSymptomList;

        getSelectedRelatedSymptomList.forEach((crtSelectedSymptom) => {
            let crtSelectedCode = crtSelectedSymptom.code;

            if (crtSelectedCode !== getMainSymptom.code) {
                let relatedSymptomCorrespondingToCrtSelectedCode = getRelatedSymptomList.filter((symptom) => {
                    return (symptom.code === crtSelectedCode && symptom.state === relatedSymptomStates.HAVE_SYMPTOM) ? true : false;
                });

                if (relatedSymptomCorrespondingToCrtSelectedCode.length === 0) {
                    commit("removeSelectedSymptomFromList", crtSelectedCode);
                }
            }
        });
    },


    /**
     * Tells the server that a related symptom's "Yes" checkbox has been checked.
     * @param {Object} context - Vuex context.
     * @param {Number} symptomCode
     * @return {Promise}
     */
    submitCheckSymptomYes(context, symptomCode) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/selectSymptom', {
                symptomCode: symptomCode
            });
            axiosRequest.then((response) => {
                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    /**
     * Tells the server that a related symptom's "No" checkbox has been checked.
     * @param {Object} context - Vuex context.
     * @param {Number} symptomCode
     * @return {Promise}
     */
    submitCheckSymptomNo(context, symptomCode) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/selectSymptomWithNo', {
                symptomCode: symptomCode
            });
            axiosRequest.then((response) => {
                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },


    /**
     * Tells the server that a related symptom's checkbox ("Yes" or "No") has been unchecked.
     * @param {Number} symptomCode
     * @return {Promise}
     */
    submitUncheckSymptom({commit}, symptomCode) {
        let promise = new Promise((resolve, reject) => {

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/deselectSymptom', {
                symptomCode: symptomCode
            });
            axiosRequest.then((response) => {
                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },


    /**
     * Send shared question's answer to the server and handle the response.
     * @param {Object} - Vuex: commit, dispatch
     * @param {Object} data - Object containing the following properties: "answerId", "questionId".
     * @return {Promise}
     */
    submitSpecificQuestionAnswer ({commit, dispatch}, data) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/provideAnswer', {
                answerCode: data.newProvidedAnswerCode,
                questionCode: data.questionCode
            });
            axiosRequest.then((response) => {

                dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });


                if(response.data.data.SYMPTOM_LIST) {
                    // ------- Refresh symptom's SPECIFIC question list. -------
                    commit("setSymptomSpecificQuestions", {
                        questionsData: response.data.data.SYMPTOM_LIST.symptoms[0].questionsData,
                        symptomCode: response.data.data.SYMPTOM_LIST.symptoms[0].code
                    });
                }

                // ------- Refresh SHARED question list. -------
                if (typeof response.data.data.SHARED_QUESTIONS !== "undefined") {
                    commit('setSharedQuestionsData', response.data.data.SHARED_QUESTIONS);
                }

                // ------- Refresh RELATED SYMPTOM list. -------
                if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined"
                    && typeof response.data.data.RELATED_SYMPTOM_LIST.symptoms !== "undefined") {
                    commit("setRelatedSymptomList", response.data.data.RELATED_SYMPTOM_LIST.symptoms);
                }


                // ----- Refresh SYMPTOM question list ------
                if(typeof response.data.data.SYMPTOM_LIST !== "undefined") {
                    commit('setSelectedRelatedSymptomList', response.data.data.SYMPTOM_LIST.symptoms );
                } else if(response.data.data.SYMPTOM_LIST_PRIORITY) {
                    commit('setSelectedRelatedSymptomListPriority', response.data.data.SYMPTOM_LIST_PRIORITY.questions);
                }

                dispatch("rectifySelectedSymptomList");

                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    /**
     * Send shared question's answer to the server and handle the response.
     * @param {Object} - Vuex: commit, dispatch
     * @param {Object} data - Object containing the following properties: "answerId", "questionId".
     * @return {Promise}
     */
    submitSharedQuestionAnswer ({commit, dispatch}, data) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/provideAnswer', {
                answerCode: data.newProvidedAnswerCode,
                questionCode: data.questionCode
            });
            axiosRequest.then((response) => {

                dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });

                // ----- Refresh SYMPTOM question list ------
                if(typeof response.data.data.SYMPTOM_LIST !== "undefined") {
                    commit('setSelectedRelatedSymptomList', response.data.data.SYMPTOM_LIST.symptoms );
                }

                // ------- Refresh SHARED question list. -------
                if (typeof response.data.data.SHARED_QUESTIONS !== "undefined") {
                    commit('setSharedQuestionsData', response.data.data.SHARED_QUESTIONS);
                }

                // ------- Refresh RELATED SYMPTOM LIST. -------
                if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined"
                    && typeof response.data.data.RELATED_SYMPTOM_LIST.symptoms !== "undefined") {
                    commit("setRelatedSymptomList", response.data.data.RELATED_SYMPTOM_LIST.symptoms);
                }

                dispatch("rectifySelectedSymptomList");

                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    }
};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    /**
     * Setter for Related Symptom list.
     * @param {Object} state
     * @param {Array} relatedSymptoms
     */
    setRelatedSymptomList (state, relatedSymptoms) {
        state.relatedSymptomList = relatedSymptoms;
    },

    /**
     * Setter for selected symptom list.
     * @param {Object} state
     * @param {Array} value
     */
    setSelectedRelatedSymptomList (state, value) {
        state.selectedRelatedSymptomList = value;
    },


    /**
     * Set specific question(s) to a symptom.
     * @param {Object} state
     * @param {Object} data - {symptomCode, questionsData}
     */
    setSymptomSpecificQuestions (state, data) {
        // @TODO Prevent DUPLICATE IDs.
        let symptomItemIndex = state.selectedRelatedSymptomList.findIndex((symptom) => {
            return symptom.code == data.symptomCode;
        });

        if (symptomItemIndex !== -1 && typeof state.selectedRelatedSymptomList[symptomItemIndex] !== "undefined") {
            state.selectedRelatedSymptomList[symptomItemIndex].questionsData = data.questionsData;
        }
    },

    /**
     * Setter for Shared Questions initial data.
     * @param {Object} state
     * @param {Object} value
     */
    setSharedQuestionsData (state, value) {
        state.sharedQuestionsData = value;
    },

    /**
     * Setter for MAIN SYMPTOM Shared Questions initial data.
     * @param {Object} state
     * @param {Object} value
     */

    setMainSymptom (state, value) {
        state.selectedMainSymptom = value;
    },

    // --------------------- ADD items to lists ---------------------

    /**
     * Add a symptom to the list of selected symptoms.
     * @param {Object} state
     * @param {Object} symptomObjToAppend
     */
    appendSelectedSymptomToList (state, symptomObjToAppend) {
        // @TODO Prevent DUPLICATE IDs.
        state.selectedRelatedSymptomList = state.selectedRelatedSymptomList.concat(symptomObjToAppend);
    },

    // --------------------- REMOVE items from lists ---------------------

    /**
     * Delete a symptom from selected symptoms list.
     * @param {Object} state
     * @param {Number} symptomCodeToRemove
     */
    removeSelectedSymptomFromList (state, symptomCodeToRemove) {
        state.selectedRelatedSymptomList = state.selectedRelatedSymptomList.filter((crtSymptom) => {
            return crtSymptom.code !== symptomCodeToRemove;
        });
    },

    // ----------------------------------------------------------

    setIsQuestionListModeEnabled (state, newVal) {
        state.isQuestionListModeEnabled = newVal;
    },

    setMustShowFullQuestion (state, newVal) {
        state.mustShowFullQuestion = newVal;
    },

    enableFooterBtnNext (state) {
        state.footerBtnNext.isEnabled = true;
    },
    disableFooterBtnNext (state) {
        state.footerBtnNext.isEnabled = false;
    },
    setSelectedRelatedSymptomListPriority (state, value) {
        state.selectedRelatedSymptomListPriority = value;
    },
    setSymptomDescription(state, newVal) {
        state.symptomDescription = newVal;
    },
    setSymptomCode(state, newVal) {
        state.symptomCode = newVal;
    },
    setMustShowAssessmentList (state, newVal) {
        state.mustShowAssessmentList = newVal;
    },
    setSymptomName(state, newVal) {
        state.symptomName = newVal;
    },
    setSymptomText(state, newVal) {
        state.symptomText = newVal;
    },
    setRelatedSymptomName(state, newVal) {
        state.relatedSymptomName = newVal;
    },
    setAnswerCode(state, newVal) {
        state.answerCode = newVal;
    },
    setNoOtherSymptomsCheck(state, newVal) {
        state.noOtherSymptomsCheck = newVal;
    },
    setNoOtherSymptoms(state, newVal) {
        state.noOtherSymptoms = newVal
    },

    // ----------------------------------------------------------

    resetStore (state) {
        state.relatedSymptomList                 = defaultState.relatedSymptomList;
        state.selectedRelatedSymptomList         = defaultState.selectedRelatedSymptomList;
        state.sharedQuestionsData                = defaultState.sharedQuestionsData;

        state.isQuestionListModeEnabled          = defaultState.isQuestionListModeEnabled;
        state.mustShowFullQuestion               = defaultState.mustShowFullQuestion;
        state.footerBtnNext = {
            isEnabled:         defaultState.footerBtnNext.isEnabled
        };
        state.selectedMainSymptom                = defaultState.selectedMainSymptom;
        state.selectedRelatedSymptomListPriority = defaultState.selectedRelatedSymptomListPriority;
        state.symptomDescription                 = defaultState.symptomDescription;
        state.symptomCode                        = defaultState.symptomCode;
        state.mustShowAssessmentList             = defaultState.mustShowAssessmentList;
        state.symptomName                        = defaultState.symptomName;
        state.symptomText                        = defaultState.symptomText;
        state.relatedSymptomName                 = defaultState.relatedSymptomName;
        state.answerCode                         = defaultState.answerCode;
        state.noOtherSymptomsCheck               = defaultState.noOtherSymptomsCheck;
        state.noOtherSymptoms                    = defaultState.noOtherSymptoms;
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/pathfinder/standard-forms/PfRelatedSymptomsStore.js